import { LocalizedTypography } from 'components/Localization/LocalizedTypography'
import {
  ProjectStateAsString,
  ProjectStatus,
} from 'controllers/Project/ProjectStateMachine'
import { ConfirmationDialogProps } from 'features/ConfirmationDialog/ConfirmationDialog'
import { useOrderProjectState } from './useOrderProjectState'
import { useProjectStateItem } from './useProjectStateItem'
import { useDialogManager } from 'features/DialogManager/DialogManager'
import { useTranslation } from 'react-i18next'
import { ErrorCountBadge } from './ErrorCountBadge'

const projectState = ProjectStatus.ORDERED
const projectStateAsString = ProjectStateAsString.ORDERED

export const OrderState = () => {
  const {
    getStateTranslationKey,
    stateItemIsCurrentOrPast,
    classes,
    changeStatus,
    SavingComponent,
    LightTooltip,
  } = useProjectStateItem(projectState)

  const { t } = useTranslation()

  const { openDialog } = useDialogManager()

  const { canChangeToOrderState, Errors, errorStyle, errorCount } =
    useOrderProjectState()

  const handleClick = () => {
    if (canChangeToOrderState) {
      openDialog('ConfirmationDialog', {
        title: t('project:order-project', 'order project'),
        message: t(
          'project:order-project-confirmation',
          'Are you sure you want to order this project?'
        ),
        onConfirm: () => {
          changeStatus(projectStateAsString)
        },
      } as ConfirmationDialogProps)
    }
  }

  return (
    <LightTooltip interactive title={errorCount > 0 ? <Errors /> : ''}>
      <li
        style={errorStyle}
        className={
          stateItemIsCurrentOrPast() ? classes.active : classes.disabled
        }
        onClick={handleClick}
      >
        <LocalizedTypography
          translationKey={getStateTranslationKey()}
          variant="body2"
        />
        <ErrorCountBadge errorCount={errorCount} />
        <SavingComponent />
      </li>
    </LightTooltip>
  )
}
